import { useEffect, useState, type CSSProperties } from 'react';

export type ColorFieldProps = {
  /** Cor válida em `#rrggbb`. */
  value: string;
  onChange: (value: string) => void;
  hint?: string;
};

export const normalizeHex = (raw: string): string | null => {
  const v = raw.trim().startsWith('#') ? raw.trim() : `#${raw.trim()}`;
  return /^#[0-9a-f]{6}$/i.test(v) ? v.toLowerCase() : null;
};

/** Cor primária do checkout: amostra com seletor nativo + código hex (`.colorrow`). */
export function ColorField({ value, onChange, hint }: ColorFieldProps) {
  const [hex, setHex] = useState(value.toUpperCase());
  useEffect(() => {
    if (normalizeHex(hex) !== value.toLowerCase()) setHex(value.toUpperCase());
  }, [value]);
  return (
    <div className="colorrow">
      <div className="colorin">
        <label className="sw" style={{ '--ck': value } as CSSProperties}>
          <input type="color" id="cpick" value={value} aria-label="Escolher cor" onChange={(e) => { onChange(e.target.value); setHex(e.target.value.toUpperCase()); }} />
        </label>
        <input
          type="text"
          id="chex"
          value={hex}
          maxLength={7}
          aria-label="Código da cor"
          aria-invalid={normalizeHex(hex) ? undefined : true}
          onChange={(e) => {
            setHex(e.target.value);
            const v = normalizeHex(e.target.value);
            if (v) onChange(v);
          }}
        />
      </div>
      {hint && <small>{hint}</small>}
    </div>
  );
}
